import type { HolidayScope, HolidayType } from '../api';

/**
 * Formata uma data civil `YYYY-MM-DD` como `dd/mm/aaaa`.
 *
 * Não passa por `Date`: a string sem hora seria lida como meia-noite UTC
 * e, convertida para Brasília, cairia no dia anterior.
 */
export function formatarDataCivil(date: string): string {
  const [y, m, d] = date.slice(0, 10).split('-');
  return y && m && d ? `${d}/${m}/${y}` : date;
}

const WEEKDAYS = ['domingo', 'segunda-feira', 'terça-feira', 'quarta-feira', 'quinta-feira', 'sexta-feira', 'sábado'];

/** Dia da semana de uma data civil, calculado em UTC para não depender do fuso. */
export function diaDaSemana(date: string): string {
  const [y, m, d] = date.slice(0, 10).split('-').map(Number);
  return WEEKDAYS[new Date(Date.UTC(y, m - 1, d)).getUTCDay()];
}

export const SCOPE_LABEL: Record<HolidayScope, string> = {
  nacional: 'Nacional',
  estadual: 'Estadual',
  municipal: 'Municipal',
};

export const TYPE_LABEL: Record<HolidayType, string> = {
  feriado: 'Feriado',
  ponto_facultativo: 'Ponto facultativo',
};
